import { render, staticRenderFns } from "./dispatchingView.vue?vue&type=template&id=50dc7530"
import script from "./dispatchingView.vue?vue&type=script&lang=ts"
export * from "./dispatchingView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports